import React from 'react';

export default function() {
  return (
    <svg width="142" height="96" viewBox="0 0 142 96">
      <g fill="none" fillRule="nonzero">
        <path
          fill="#459FED"
          d="M102.966 46.884H29.872a6.7 6.7 0 0 0-5.086 2.339l-4.693 5.475h92.651l-4.693-5.475a6.697 6.697 0 0 0-5.085-2.339"
        />
        <path
          fill="#4EB7F5"
          d="M58.211 79.264c-5.21 0-10.177-3.027-12.4-8.106-2.997-6.845.122-14.822 6.966-17.82l.78-.34a18.782 18.782 0 0 0 9.534-9.344l5.335-11.56a25.853 25.853 0 0 1 21.628-14.952c7.708-.544 15.7 2.421 21.381 7.946a27.005 27.005 0 0 1 3.958 4.838c2.711 4.253-2.819 27.364-10.272 27.053-6.74-.294-12.115-5.47-12.855-11.968l-4.608 9.982a45.798 45.798 0 0 1-23.252 22.792l-.775.34a13.48 13.48 0 0 1-5.42 1.14z"
        />
        <path
          fill="#D8EFFD"
          d="M8.372 96H.558a.558.558 0 0 1 0-1.116h7.814a.557.557 0 1 1 0 1.115M118.883 96H13.953a.558.558 0 0 1 0-1.116h104.93a.557.557 0 1 1 0 1.115M135.628 96h-11.163a.558.558 0 0 1 0-1.116h11.163a.557.557 0 1 1 0 1.115"
        />
        <path
          fill="#B0DFFB"
          d="M106.046 96H26.79c-3.698 0-6.697-2.999-6.697-6.697V54.698h92.651v34.605c0 3.698-3 6.697-6.698 6.697"
        />
        <path fill="#459FED" d="M76.465 69.21H56.372a3.907 3.907 0 1 1 0-7.814h20.093a3.906 3.906 0 1 1 0 7.814" />
        <path
          fill="#B0DFFB"
          d="M7.256 70.326a1.675 1.675 0 0 1-1.24-2.8l9.834-10.819a6.153 6.153 0 0 1 4.544-2.009h2.49a1.675 1.675 0 0 1 0 3.349h-2.49c-.786 0-1.538.333-2.066.913L8.495 69.778a1.671 1.671 0 0 1-1.24.548M125.581 70.326c-.454 0-.907-.184-1.239-.548l-9.834-10.819a2.796 2.796 0 0 0-2.065-.912h-2.49a1.675 1.675 0 0 1 0-3.349h2.49c1.726 0 3.383.732 4.544 2.01l9.833 10.817a1.675 1.675 0 0 1-1.239 2.801"
        />
        <path fill="#75C7F7" d="M108.837 54.698h-26.79a3.907 3.907 0 1 1 0-7.814h26.79a3.906 3.906 0 1 1 0 7.814" />
        <path
          fill="#4EB7F5"
          d="M106.044 33.489a2.233 2.233 0 0 1-.365-4.435l6.084-1.015a11.102 11.102 0 0 0 8.47-6.717l4.875-11.706A15.59 15.59 0 0 1 139.535 0a2.233 2.233 0 0 1 0 4.466c-4.521 0-8.567 2.695-10.305 6.868l-4.876 11.706a15.54 15.54 0 0 1-11.858 9.403l-6.082 1.016c-.124.02-.25.03-.37.03"
        />
        <path
          fill="#75C7F7"
          d="M112.744 54.698H97.116a4.465 4.465 0 0 1-3.572-1.787L85.73 42.493a4.465 4.465 0 0 1-.893-2.68v-2.417c0-8.94 7.247-16.186 16.186-16.186 8.94 0 16.186 7.246 16.186 16.186v12.837c0 2.466-2 4.465-4.465 4.465"
        />
        <path
          fill="#4EB7F5"
          d="M39.627 40.186a.558.558 0 0 1-.556-.523c-.22-3.493.079-10.357 4.557-17.088 4.068-6.115 9.598-9.05 12.533-10.254.28-.112.61.02.728.306a.56.56 0 0 1-.306.727c-2.815 1.156-8.122 3.972-12.026 9.84-4.296 6.458-4.583 13.046-4.372 16.4a.558.558 0 0 1-.523.591l-.035.001M34.046 36.838a.556.556 0 0 1-.539-.416c-.106-.4-2.546-9.901 2.307-17.196a.558.558 0 0 1 .93.619c-4.57 6.87-2.183 16.198-2.159 16.292a.557.557 0 0 1-.539.7"
        />
      </g>
    </svg>
  );
}
